import { SHARED_KEY } from '@silverfort-nodelibs/common/utils/consts';
import { calcInvalidTabs, clearNotifications, validateAll, validateCrossFields } from './utils';
import { IS_NEW_FIELD } from './fields';

export const VALIDATE = 'validate';
export const SAVE_SETTINGS = 'save_settings';
export const DISCARD = 'discard';
export const RELOAD_STATE = 'reload_state';

const clearTabIsDirty = (newState, selectedTab) => {
    for (const fieldId in newState[selectedTab].fields) {
        if (fieldId === SHARED_KEY) continue;
        newState[selectedTab].fields[fieldId].isDirty = false;
        newState[selectedTab].fields[fieldId].initialValue = newState[selectedTab].fields[fieldId].value;
        if (newState[selectedTab].fields[fieldId].id === IS_NEW_FIELD.ID) {
            newState[selectedTab].fields[fieldId].value = false;
            newState[selectedTab].fields[fieldId].initialValue = false;
        }
        if (Array.isArray(newState[selectedTab].fields[fieldId].value)) {
            for (const arrayFieldIndex in newState[selectedTab].fields[fieldId].value) {
                for (const arrayFieldId in newState[selectedTab].fields[fieldId].value[arrayFieldIndex]) {
                    if (arrayFieldId === 'fields') {
                        for (const innerFieldId in newState[selectedTab].fields[fieldId].value[arrayFieldIndex]
                            .fields) {
                            const arrayField =
                                newState[selectedTab].fields[fieldId].value[arrayFieldIndex].fields[innerFieldId];
                            if (
                                typeof arrayField === 'object' &&
                                arrayField !== null &&
                                arrayField.value !== undefined &&
                                arrayField.isDirty !== undefined
                            ) {
                                newState[selectedTab].fields[fieldId].value[arrayFieldIndex].fields[
                                    innerFieldId
                                ].isDirty = false;
                                newState[selectedTab].fields[fieldId].value[arrayFieldIndex].fields[
                                    innerFieldId
                                ].initialValue = arrayField.value;
                                if (arrayField.id === IS_NEW_FIELD.ID) {
                                    newState[selectedTab].fields[fieldId].value[arrayFieldIndex].fields[
                                        innerFieldId
                                    ].value = false;
                                    newState[selectedTab].fields[fieldId].value[arrayFieldIndex].fields[
                                        innerFieldId
                                    ].initialValue = false;
                                }
                            }
                        }
                    } else {
                        const arrayField = newState[selectedTab].fields[fieldId].value[arrayFieldIndex][arrayFieldId];
                        if (
                            typeof arrayField === 'object' &&
                            arrayField !== null &&
                            arrayField.value !== undefined &&
                            arrayField.isDirty !== undefined
                        ) {
                            newState[selectedTab].fields[fieldId].value[arrayFieldIndex][arrayFieldId].isDirty = false;
                            newState[selectedTab].fields[fieldId].value[arrayFieldIndex][arrayFieldId].initialValue =
                                arrayField.value;
                            if (arrayField.id === IS_NEW_FIELD.ID) {
                                newState[selectedTab].fields[fieldId].value[arrayFieldIndex][
                                    arrayFieldId
                                ].value = false;
                                newState[selectedTab].fields[fieldId].value[arrayFieldIndex][
                                    arrayFieldId
                                ].initialValue = false;
                            }
                        }
                    }
                }
            }
        }
    }
};

export const commonActionsReducer = (state, action, initFieldsState) => {
    switch (action.type) {
        case VALIDATE:
            const { selectedTab: selectedTabValidate, ignoredFields } = action.payload;
            const validatedState = validateAll(state, ignoredFields);
            const invalidTabs = calcInvalidTabs(validatedState);
            if (invalidTabs.length > 0) {
                return validatedState;
            }
            return validateCrossFields(validatedState, selectedTabValidate);
        case SAVE_SETTINGS:
            const { selectedTab, saveAll } = action.payload;
            const newState = { ...state };
            if (saveAll) {
                for (const categoryKey of Object.keys(state)) {
                    clearTabIsDirty(newState, categoryKey);
                }
            } else {
                clearTabIsDirty(newState, selectedTab);
            }

            return clearNotifications(newState, selectedTab, saveAll);
        case DISCARD:
            const initialFieldsState = initFieldsState({
                settings: action.payload.settings,
                ...action.payload.discardExtra
            });
            const newFieldsState = { ...action.payload.fields };
            newFieldsState[action.payload.selectedTab] = initialFieldsState[action.payload.selectedTab];
            return newFieldsState;
        case RELOAD_STATE:
            return initFieldsState({
                settings: action.payload.settings,
                ...action.payload.discardExtra
            });
        default:
            throw new Error();
    }
};
